import { useEffect } from "react";
import FaqAccordian from "../home_page/FaqAccordian";

const Faq = () => {
  useEffect(() => {
    document.title = "FAQ | Kloudscan";
  }, []);

  return <FaqAccordian />;
};

export default Faq;
